import React, { useState, useEffect, useRef } from 'react'
import {
    InputBase,
    Grid,
    Button,
    IconButton,
    Link,
    Typography
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import PublishIcon from '@material-ui/icons/Publish';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../../../components/table/SearchGrid';
import Breadcrums from '../../../../components/BreadCrums/breadcrums';
import TopSpacer from '../../../../components/Common/spacer/TopSpacer';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { PostDataAPI } from '../../../../Services/APIService';
import Loader from '../../../../components/Loader/Loader';
import { ActionDialog } from "../../../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../../../components/Message/Alert";
import AddNewAgency from './addNew/AddNewAgency';
import { SelectField, InputBaseField, TextareaField } from '../../../../components/InputField/InputField';
import { AttachFile } from '@material-ui/icons';
import { DraggableComponent, FormBtn, FormGroupTitle, Label, ErrorMessage, LinkS, ShadowBoxMin } from "../../../../components/UiElements/UiElements";
import GetAppIcon from '@material-ui/icons/GetApp';


function AgencyList({ trackingType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});
    const [agencyCounts, setAgencyCounts] = useState({});
    

    const [newAgency, setNewAgency] = useState(false);
    const [selectedAgencyId, setSelectedAgencyId] = useState(0);

    const OpenNewAgency = () => {
        setSelectedAgencyId(0)
        setNewAgency(true)
    }

    const CloseAgencyDialog = () => {
        setNewAgency(false)
    }

    const editList = (item) => {
        setSelectedAgencyId(item.agencyId);
        setNewAgency(true)
    }

    const deleteList = (record) => {
        showActionDialog("This agency will be removed from all distribution lists, are you sure you want to delete?", "confirm", function () {
            setIsLoading(true);
            var method = "fdnagency/delete";

            PostDataAPI(method, record, true).then((result) => {
                if (result.success) {
                    if (result.data) {
                        setIsLoading(false);
                        var message = "Agency deleted from all distribution lists";
                        handleSuccessClose(message);

                    }
                    else {
                        showMessage("Error", "Error deleting agency, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
                setIsLoading(false);

            })
        });
    }

    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [state, setState] = useState({});


    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [agencyList, setAgencyList] = useState([]);

    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }


    const [filteredStatus, setFilteredStatus] = useState([]);


    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();
    };

    const loadAgencyListGrid = () => {
        setIsLoading(true);
        var params = { agencyCategory: 'PR' }
        PostDataAPI("fdnagency/loadGrid", params).then((result) => {
            if (result.success && result.data != null) {
                setAgencyList(result.data);
                var agencyFilterByRegion = getDistinctAgencyCount(result.data);
            }
            else {
                setAgencyList([]);
            }
            handleDataGridUpdate();
            setIsLoading(false);

        })
    }
    const inputFile = useRef(null);
    const handleSuccessClose = (message) => {
        CloseAgencyDialog();
        showMessage("Success", message, "success", 3000);
        loadAgencyListGrid();
    }
    function handleFileUpload(e) {

        var ext = e.target.files[0].name.match(/\.(.+)$/)[1];

        switch (ext) {
            case 'xlsx':
                break;
            default:
                showMessage("Error", "This file format is not allowed,\n Only Excel files are allowed.", "error", 3000);
                document.getElementById("fileUploadField").value = '';
                return;
        }

        //setAttachment({ file: e.target.files[0] ? e.target.files[0] : null, userFileName: e.target.files[0] ? e.target.files[0].name : null });
        
        importAgencies({ file: e.target.files[0] ? e.target.files[0] : null, userFileName: e.target.files[0] ? e.target.files[0].name : null });
        e.target.value = "";
    }
    const handleSelectFile = () => {
        inputFile.current.click();
    };

    const importAgencies = (attachment) => {


        let method = "fdnagency/importAgencies";

        const formData = new FormData();

        setIsLoading(true);

        formData.append("excelFile", attachment.file);
        formData.append("agencyCategory", "PR");
        PostDataAPI(method, formData, true, "formData").then((result) => {
            setIsLoading(false);

            if (result.success == true) {

                //setErrorMessages([]);

                if (result.success && result.data != null) {
                    showMessage("Success", "Agencies imported successfully.", "success", 3000);
                    loadAgencyListGrid();
                    //setAttachment({ file: null, userFileName: null });
                }
            }
            else {
                let errorMessage = result.message.split('.')[0];
                let userID = result.message.split('^')[2];
                if (errorMessage.trim() == 'There are error(s) in excel file') {
                    window.location.assign("." + "\\Documents\\temp\\" + userID + "\\" + result.message.split('^')[1]);
                    showMessage("Error", "There are error(s) in the uploaded fie, Please fix the errors and try again.", "error", 3000);
                }
                else
                    showMessage("Error", errorMessage, "error", 3000);
            }
        })

    }
    //get agency count by region
    const getDistinctAgencyCount = (record) => {
        const agencyCounts = {};
        record.forEach(item => {
            const agency = item.region;
            agencyCounts[agency] = (agencyCounts[agency] || 0) + 1;
        });
        setAgencyCounts(agencyCounts);
    }

    useEffect(() => {
      loadAgencyListGrid();        
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
           
            <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
                {/*<InputBaseField*/}
                {/*    id="agencyExcelFile"*/}
                {/*    name="agencyExcelFile"*/}
                {/*    value={attachment.userFileName}*/}
                {/*    onChange={handleChange}*/}
                {/*    IsDisabled={true}*/}
                {/*    placeholder={"Choose a file"}*/}
                {/*    endAdornment={*/}
                {/*        <IconButton*/}
                {/*            className={classes.attachmentBtn}*/}
                {/*            color="primary"*/}
                {/*            onClick={handleSelectFile}>*/}
                {/*            <AttachFile />*/}
                {/*        </IconButton>*/}
                {/*    }*/}
                {/*/>*/}
            </Grid>
            <Grid row className={classes.gridHeader}>
                <div className={classes.labelBullet}>

                    {Object.entries(agencyCounts).map(([agency, count]) => (
                        <li key={agency}>
                            {agency === 'null' ? 'Other' : agency}: {count}
                        </li>
                    ))}

                </div>
                <div className={classes.gridActions}>
                  
                        
                        <LinkS className={classes.changeBtn} style={{alignItems: 'center', display: 'inline-flex'}} download={"Agency_Import_Template.xlsx"} href={"." + "\\Documents\\templates\\Agency_Import_Template.xlsx"}>
                              <GetAppIcon style={{ marginRight: '6px' }} /> Download template
                        </LinkS>

                    <Button className={classes.changeBtn} onClick={() => handleSelectFile()}><PublishIcon style={{ marginRight: '6px' }} /> Import</Button>
                    <Button className={classes.changeBtn} onClick={() => OpenNewAgency()}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> Add New</Button>
                </div>

                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                    />
                </div>

            </Grid>

            <Grid row className={classes.container} >
                <SearchGrid columns="AgencyList"
                    list={agencyList}
                    noRecordMsg="No record exists"
                    Icon={true}
                    filter={searchFilter}
                    onEditClick={editList}
                    onDeleteClick={deleteList}
                    isUpdate={isDataGridUpdate}
                    callBackFilteredRecord={getDistinctAgencyCount}
                />
            </Grid>

            {newAgency ?
                <AddNewAgency
                    dialogOpenClose={OpenNewAgency}
                    handleClose={CloseAgencyDialog}
                    handleSuccessClose={handleSuccessClose}
                    selectedAgencyId={selectedAgencyId}
                ></AddNewAgency>
                : ""}
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>

                {/*<Typography className={classes.fileLink} style={{ fontSize: "16px" }} >*/}
                {/*    <LinkS onClick={"." + "\\Documents\\templates\\Agency_Import_Template.xlsx"} download={"Agency_Import_Template.xlsx"} href={"." + "\\Documents\\template\\Agency_Import_Template.xlsx"}>*/}
                {/*        <u>Download template</u>*/}
                {/*    </LinkS></Typography>*/}

                <form>
                    <div>
                        <input ref={inputFile} style={{ display: "none" }} type="file" id="fileUploadField" onChange={handleFileUpload} accept=".xlsx,.xls,.xlsm" />
                    </div>
                </form>
            </Grid>
        </>
    )

}

export default withSnackbar(AgencyList);